import { getToken } from '../auth/api';
import axios from 'axios';
import { TAG_DATA_KEYS, TAGS_URL } from './utilsConstants';
import { BEARER_TOKEN_ID } from '../constants/constants';

export default (activeOrganizationAccount: string, id: string, tags: Array<string>) => {
    const token = getToken();

    const formData = new FormData();
    formData.append(TAG_DATA_KEYS.id, id);
    formData.append(TAG_DATA_KEYS.tags, tags.join(','));

    const headers = {
        ownerId: activeOrganizationAccount,
        Authorization: token ? BEARER_TOKEN_ID + token.token : ''
    };

    return axios.post(TAGS_URL, formData, { headers });
};
